const yup = require('yup')

const scheduleDate = () =>
  yup
    .date()
    .nullable()
    .when('schedule', { is: 'scheduled', then: (s) => s.required(), otherwise: (s) => s.transform(() => null) })

module.exports = scheduleDate
